// extracted by mini-css-extract-plugin
export default {"debug-bar":"index_debug-bar__HG6T-"};